module.exports = __webpack_public_path__ + "img/jg.e19c5616.png";